import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';
import z from 'zod';

const workInstructionProcessListCellAttrsSchema = cellCfgAttrsBaseSchema.extend({
    workInstructionId: z.string(),
    orientation: z.union([ z.literal('horizontal'), z.literal('vertical') ]),
});

export const workInstructionProcessListCellSchema = cellCfgBaseSchema.extend({
    type: z.literal('workInstructionProcessList'),
    attrs: workInstructionProcessListCellAttrsSchema,
});
